/**
 * Map Layout Store
 * Manages map overlay/layout state (e.g., panel expansions that affect control positioning)
 */
import { create } from 'zustand';

interface MapLayoutStore {
  layersPanelExpanded: boolean;
  newsPanelExpanded: boolean;
  aiAssistantPanelExpanded: boolean;

  // Actions
  setLayersPanelExpanded: (expanded: boolean) => void;
  setNewsPanelExpanded: (expanded: boolean) => void;
  setAiAssistantPanelExpanded: (expanded: boolean) => void;
}

export const useMapLayoutStore = create<MapLayoutStore>((set) => ({
  layersPanelExpanded: false,
  newsPanelExpanded: false,
  aiAssistantPanelExpanded: false,
  setLayersPanelExpanded: (expanded) => set({ layersPanelExpanded: expanded }),
  setNewsPanelExpanded: (expanded) => set({ newsPanelExpanded: expanded }),
  setAiAssistantPanelExpanded: (expanded) => set({ aiAssistantPanelExpanded: expanded }),
}));
